import { render, staticRenderFns } from "./UrunDigerMisafirItem.vue?vue&type=template&id=2ad894ab&scoped=true"
import script from "./UrunDigerMisafirItem.vue?vue&type=script&lang=js"
export * from "./UrunDigerMisafirItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad894ab",
  null
  
)

export default component.exports